import React, { useState, useContext } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Logo from "../../assets/images/login_logo.png";
import { UserContext } from "../../contexts/UserContext";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const Login = ({ onLoginSuccess, closeModal }) => {
const Login = ({ closeModal, switchToRegister }) => {
  const { login } = useContext(UserContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate(); // hook to navigate programmatically

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await axios.post(`${API_BASE_URL}/api/users/login`, {
        username,
        password,
      });

      if (res.data.user && res.data.token) {
        login(res.data.user, res.data.token);
      } else {
        setError(res.data.message || "Login failed");
      }
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    }

    setLoading(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <img className="img-thumbnail mx-auto d-block mb-3" src={Logo} alt="logo" width="60" />
      <h4 className="text-center mb-3">Sign In</h4>

      {error && (
        <Alert variant="danger" onClose={() => setError("")} dismissible>
          {error}
        </Alert>
      )}

      <Form.Group className="mb-3" controlId="username">
        <Form.Label>Username</Form.Label>
        <Form.Control
          type="text"
          value={username}
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mb-4" controlId="password">
        <Form.Label>Password</Form.Label>
        <Form.Control
          type="password"
          value={password}
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </Form.Group>

      <Button className="w-100" type="submit" variant="primary" disabled={loading}>
        {loading ? "Logging In..." : "Log In"}
      </Button>


<div className="text-center mt-3">
  <small>
    Don't have an account?{" "}
    <span
      onClick={switchToRegister}
      style={{ color: "#0d6efd", cursor: "pointer" }}
    >
      Register
    </span>
  </small>
</div>

    </Form>
  );
};

export default Login;
